"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[40728],{

/***/ 15740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RegisterTradingModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29658);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48085);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38305);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41110);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70175);











function RegisterTradingModal(param) {
    var visible = param.visible, onClose = param.onClose;
    var closeModal = (0,_store__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(state) {
        return state.closeModal;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), loading = ref[0], setloading = ref[1];
    var handleClose = function() {
        closeModal();
        if (onClose) {
            onClose();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalContainer */ .EB, {
        "data-cy": "register-trading-modal",
        visible: visible,
        centered: true,
        width: 751,
        onCancel: handleClose,
        zIndex: 1050,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .CarouselContainer */ .am, {
                    justify: "center",
                    align: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .Carousel */ .lr, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .RegisterInfoContainer */ .un, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            condition: loading,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .AuthModalLoading */ .FL, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            condition: !loading,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    family: "bold",
                                    size: "24px",
                                    mb: "8px",
                                    children: "Mulai Investasi di Saham bersama Stockbit"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    mb: "40px",
                                    children: "Download aplikasi Stockbit untuk membuka akun trading dan mulai perjalanan investasimu dengan lebih mudah. Scan QR Code di bawah ini."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    justify: "space-between",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_blank",
                                                    href: constants_api__WEBPACK_IMPORTED_MODULE_4__/* .GOOGLE_PLAY_URL */ .VE,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        alt: "android",
                                                        src: "/images/google-play.png",
                                                        style: {
                                                            height: "40px",
                                                            marginBottom: "24px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_blank",
                                                    href: constants_api__WEBPACK_IMPORTED_MODULE_4__/* .APP_STORE_URL */ .l5,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        alt: "iOS",
                                                        src: "/images/app-store.png",
                                                        style: {
                                                            height: "40px"
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .RegisterInfoDivider */ .kp, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            src: "/img/stockbit-qr.svg",
                                            alt: "stockbit app qr code"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    justify: "space-between",
                                    align: "center",
                                    mt: "40px",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            size: "16px",
                                            color: "#858585",
                                            children: "Or Switch Platform"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .VirtualTradingButton */ .qW, {
                                            title: "Virtual Trading",
                                            type: _types__WEBPACK_IMPORTED_MODULE_8__/* .AuthModalType.REGISTER */ .O.REGISTER,
                                            setLoading: setloading
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 54855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AUTH_MODAL_CONFIG; },
/* harmony export */   "q": function() { return /* binding */ AUTH_ORDER_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);

var AUTH_ORDER_TYPE = {
    BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
    SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
    AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
    AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
};
var AUTH_MODAL_CONFIG = {
    real: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
    },
    virtual: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_BUY */ .Jm.VIRTUAL_BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_SELL */ .Jm.VIRTUAL_SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_BUY */ .Jm.VIRTUAL_AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_SELL */ .Jm.VIRTUAL_AMEND_SELL
    }
};


/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 48085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EB": function() { return /* binding */ AuthModalContainer; },
/* harmony export */   "GX": function() { return /* binding */ ButtonSubmit; },
/* harmony export */   "Ue": function() { return /* binding */ LoginTradingModalContainer; },
/* harmony export */   "X4": function() { return /* binding */ ProgressRejectedAuthModalContainer; },
/* harmony export */   "am": function() { return /* binding */ CarouselContainer; },
/* harmony export */   "kp": function() { return /* binding */ RegisterInfoDivider; },
/* harmony export */   "rG": function() { return /* binding */ LoginInfoDivider; },
/* harmony export */   "un": function() { return /* binding */ RegisterInfoContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 40px 40px 20px 40px;\n  }\n\n  /* Fade In & Scale Up Animation */\n  @keyframes fadeScaleIn {\n    from {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  /* Fade Out & Scale Down Animation */\n  @keyframes fadeScaleOut {\n    from {\n      opacity: 1;\n      transform: scale(1);\n    }\n    to {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n  }\n\n  /* Ant Design Modal Animation Overrides */\n  .custom-modal-enter {\n    animation: fadeScaleIn 0.5s ease-out;\n  }\n\n  .custom-modal-leave {\n    animation: fadeScaleOut 0.5s ease-in;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 360px;\n  min-height: 492px;\n  background-color: #5dcbad26;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 391px;\n  padding: 40px 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 1px;\n  height: 144px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 185px;\n  height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 160px;\n  height: 40px;\n  gap: 10px;\n  padding-top: 10px;\n  padding-right: 20px;\n  padding-bottom: 10px;\n  padding-left: 20px;\n  border-radius: 4px;\n  background: #00AB6B;\n  border: none;\n  color: #FFF;\n  font-family: var(--font-bold);\n  cursor: pointer;\n\n  :disabled {\n    background: #CCEEE1;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var AuthModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ab604be6-0"
})(_templateObject());
var ProgressRejectedAuthModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AuthModalContainer).withConfig({
    componentId: "sc-ab604be6-1"
})(_templateObject1());
var LoginTradingModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AuthModalContainer).withConfig({
    componentId: "sc-ab604be6-2"
})(_templateObject2());
var CarouselContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ab604be6-3"
})(_templateObject3());
var RegisterInfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-4"
})(_templateObject4());
var RegisterInfoDivider = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var LoginInfoDivider = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var ButtonSubmit = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-ab604be6-7"
})(_templateObject7());


/***/ }),

/***/ 41110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ AuthModalType; },
/* harmony export */   "X": function() { return /* binding */ AuthModalStatus; }
/* harmony export */ });
var AuthModalType;
(function(AuthModalType) {
    AuthModalType["LOGIN"] = "login";
    AuthModalType["REGISTER"] = "register";
    AuthModalType["PROGRESS"] = "progress";
})(AuthModalType || (AuthModalType = {}));
var AuthModalStatus;
(function(AuthModalStatus) {
    AuthModalStatus[AuthModalStatus["UNREGISTERED"] = 0] = "UNREGISTERED";
    AuthModalStatus[AuthModalStatus["INCOMPLETE"] = 1] = "INCOMPLETE";
    AuthModalStatus[AuthModalStatus["CS"] = 2] = "CS";
    AuthModalStatus[AuthModalStatus["KSEI"] = 3] = "KSEI";
    AuthModalStatus[AuthModalStatus["RDN"] = 4] = "RDN";
    AuthModalStatus[AuthModalStatus["REJECTED"] = 99] = "REJECTED";
    AuthModalStatus[AuthModalStatus["COMPLETED"] = 100] = "COMPLETED";
})(AuthModalStatus || (AuthModalStatus = {}));


/***/ }),

/***/ 22405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LinkError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 19 modules
var modal = __webpack_require__(33070);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./src/global/Icons/CloseSvg.tsx
var CloseSvg = __webpack_require__(79928);
;// CONCATENATED MODULE: ./src/global/LinkError/link-error.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 400px;\n  margin: 0 auto;\n\n  & .ant-modal-wrap {\n    z-index: 9999;\n  }\n\n  & .ant-modal-header {\n    display: none;\n  }\n\n  & .ant-modal-content {\n    border-radius: 4px;\n  }\n\n  & .ant-modal-body {\n    padding: 40px 20px 20px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #c1c1c1;\n  font-size: 10px;\n  transition: 0.3s color linear;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    width: 160px;\n    height: 120px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 700;\n  color: #333333;\n  margin: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  color: #858585;\n  margin: 0;\n  text-align: center;\n  width: 90%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-top: 40px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 13px;\n  line-height: 18px;\n  font-style: normal;\n  font-weight: 700;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-155802cb-0"
})(_templateObject());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.Z).attrs({
    component: CloseSvg/* default */.Z
}).withConfig({
    componentId: "sc-155802cb-1"
})(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-155802cb-2"
})(_templateObject2());
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-155802cb-3"
})(_templateObject3());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-155802cb-4"
})(_templateObject4());
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-155802cb-5"
})(_templateObject5());
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-155802cb-6"
})(_templateObject6());
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-155802cb-7"
})(_templateObject7());
var Button = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-155802cb-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/global/LinkError/index.tsx



function LinkError(param) {
    var visible = param.visible, onSubmit = param.onSubmit, onCancel = param.onCancel, title = param.title, description = param.description, _showTopDescription = param.showTopDescription, showTopDescription = _showTopDescription === void 0 ? false : _showTopDescription;
    var errorImage = "/illustration/stream-error-link.svg";
    var handleSubmit = function() {
        onSubmit();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        centered: true,
        title: null,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
        footer: null,
        visible: visible,
        onOk: handleSubmit,
        onCancel: onCancel,
        zIndex: 1050,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: errorImage,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            style: {
                                marginTop: 16
                            },
                            children: title
                        }),
                        showTopDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            style: {
                                width: 310
                            },
                            children: "Buka akun Stockbit Sekuritas terlebih dahulu untuk verifikasi data identitas kamu."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            style: {
                                marginTop: 16
                            },
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        type: "primary",
                        onClick: handleSubmit,
                        children: "Buka Akun Stockbit Sekuritas"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    formType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false,
    trailingStop: undefined,
    setToMaxLot: false,
    isGtc: undefined
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setPrice: function(price) {
            set({
                price: price
            });
        },
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ }),

/***/ 86408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ getFormula; },
  "u": function() { return /* binding */ postCancel; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/config.ts
var configEndpoint = {
    formula: "/virtualtrading/config/formula",
    cancel: "/virtualtrading/cancel"
};
/* harmony default export */ var config = (configEndpoint);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/config.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getFormula = function() {
    return defaultInstance.get(config.formula);
};
var postCancel = function(requestBody) {
    return defaultInstance.post(config.cancel, requestBody);
};


/***/ })

}]);